// ==============================|| coogoong ||============================== //
import CoogoongFavicon from './coogoong/favicon-coogoong.png';
import CoogoongNaviLogo from './coogoong/navi-logo.png';
import CoogoongTitleLogo from './coogoong/title-logo.png';
import CoogoongKvBg from './coogoong/kv-bg.png';
import CoogoongKvText from './coogoong/kv-text.png';
import CoogoongIconVote from './coogoong/icon-vote.png';
import CoogoongIconAd from './coogoong/icon-ad.png';
import CoogoongIconCommunity from './coogoong/icon-community.png';
import CoogoongIconMoment from './coogoong/icon-moment.png';
import CoogoongIconCommerce from './coogoong/icon-commerce.png';
import CoogoongIconRookie from './coogoong/icon-rookie.png';

export default {
	CoogoongFavicon,
	CoogoongNaviLogo,
	CoogoongTitleLogo,
	CoogoongKvBg,
	CoogoongKvText,
	CoogoongIconVote,
	CoogoongIconAd,
	CoogoongIconCommunity,
	CoogoongIconMoment,
	CoogoongIconCommerce,
	CoogoongIconRookie
};
